// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fqamqdsxcsqfepmssrpq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZxYW1xZHN4Y3NxZmVwbXNzcnBxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0MTQ5OTAsImV4cCI6MjA4ODk5MDk5MH0.DSYc5ixcHUz-C3ZlS33rKjN1qkWWDgYut9gfLJ8nCIE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});